<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive table-desi table-product">
                        <v-data-table-server
                            class="table table-1d all-package blogGrid"
                            v-model:items-per-page="itemsPerPage"
                            :search="search"
                            :headers="showHeaders"
                            :items-length="pagination.total"
                            :items="dataBlogGrid"
                            :loading="loading"
                            item-value="author"
                            @update:options="getBlogGrid"
                        >
                            <template v-slot:thead>
                                <tbody>
                                    <tr>
                                        <td v-if="selectedHeaders.includes('id')">
                                            <v-text-field v-model="id" hide-details placeholder="Search id..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('author')">
                                            <v-text-field v-model="author" hide-details placeholder="Search author..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('title')">
                                            <v-text-field v-model="title" hide-details placeholder="Search title..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('image')"></td>

                                        <td v-if="selectedHeaders.includes('active')"></td>

                                        <td v-if="selectedHeaders.includes('actions')"></td>
                                    </tr>
                                </tbody>
                            </template>

                            <template v-slot:item.image="{ item }">
                                <v-card class="my-2 v-responsive v-img rounded">
                                    <v-img :src="`${item.multimedia[0].path}${item.multimedia[0].name}`"></v-img>
                                </v-card>
                            </template>
                            
                            <template v-slot:item.active="{ item }">
                                <v-checkbox class="ma-2"
                                    v-model="item.active"
                                    readonly
                                ></v-checkbox>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-btn color="primary" class="elevation-0" icon variant="plain" @click="editBlog(item)"> <v-icon> mdi-pencil-outline </v-icon> </v-btn>
                                <!--  FALTA - se quiere eliminar? Hay estado de Activo - Hecho en Vendor
                                <v-btn color="error"   class="elevation-0" icon variant="plain" @click="dialogDeleteBlog = true"><v-icon> mdi-trash-can-outline </v-icon> </v-btn>
                                -->
                                <v-dialog v-model="dialogDeleteBlog" max-width="600px">
                                    <v-card>
                                        <v-card-title class="confirmation-dialog" primary-title>Confirmation</v-card-title>
                                        <v-card-text> Are you sure you want to delete the blog with the title '{{ item.title }}'? </v-card-text>
                                        <v-card-actions>
                                            <v-btn color="red"   text @click="dialogDeleteBlog = false">Cancel</v-btn>
                                            <v-btn color="green" text @click="deleteBlog(item)">Delete</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </template>
                        </v-data-table-server>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { objectExpression } from '@babel/types'

export default {
    title: 'Blogs',
    props: {},
    data() {
        return {
            dataBlogGrid: ref([]),
            pagination: ref({
                from: 0,
                to: 0,
                total: 0,
                current: 1,
                lastPage: 0
            }),
            itemsPerPage: 10,
            selectedHeaders: ['author', 'title', 'image', 'active','actions'],
            headers: [
                {
                    title: 'ID',
                    align: 'start',
                    sortable: true,
                    key: 'id'
                },
                {
                    title: 'Author',
                    align: 'center',
                    sortable: true,
                    key: 'author'
                },
                {
                    title: 'Title',
                    align: 'center',
                    sortable: true,
                    key: 'title'
                },
                {
                    title: 'Image',
                    align: 'center',
                    sortable: false,
                    key: 'image',
                    value: 'image'
                },
                {
                    title: 'Active',
                    align: 'center',
                    sortable: true,
                    key: 'active',
                    value: 'active'
                },
                {
                    title: 'Actions',
                    align: 'center',
                    sortable: false,
                    key: 'actions'
                }
            ],
            loading: true,

            // Filtros search
            search: '',
            id: '',
            author: '',
            title: '',

            dialogDeleteBlog: false
        }
    },
    watch: {
        id() {
            this.search = String(Date.now())
        },
        author() {
            this.search = String(Date.now())
        },
        title() {
            this.search = String(Date.now())
        }
    },
    computed: {
        //Done to get the ordered headers
        showHeaders() {
            return this.headers.filter((s) => this.selectedHeaders.includes(s.key))
        }
    },
    methods: {
        /*      loadItems({ page, itemsPerPage, sortBy }) {
          
            this.loading = true
            FakeAPI.fetch({
                page,
                itemsPerPage,
                sortBy,
                search: { name: this.name, calories: this.calories }
            }).then(({ items, total }) => {
                this.serverItems = items
                this.totalItems = total
                this.loading = false
            })
            
        }, */
        getBlogGrid({ page, itemsPerPage, sortBy, search }) {
            let self = this
            this.loading = true
            
            //Aplicamos los filtros
            let apiURL = process.env.VUE_APP_URL_API_BASE + '/blog/grid?page=' + page + '&limit=' + itemsPerPage + '&id=' + self.id + '&author=' + self.author + '&title=' + self.title

            //Aplicamos el orden
            if (sortBy && sortBy[0]) {
                apiURL = apiURL + '&sort=' + sortBy[0].key + '&order=' + sortBy[0].order
            }

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        
                        // Obtenemos la data de dentro de blog guardandola en dataBlogGrid
                        self.dataBlogGrid = []
                        response.data.data.forEach(function (option) {
                            if (option) {
                                //Estos dos tienen multilenguaje
                                option.content = option.content.es
                                option.title = option.title.es
                                
                                self.dataBlogGrid.push(option)
                            }
                        })

                        self.pagination.from = response.data.from
                        self.pagination.to = response.data.to
                        self.pagination.total = response.data.total
                        self.pagination.current = response.data.current_page
                        self.pagination.lastPage = response.data.last_page
                        this.loading = false
                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        newBlog(item) {
            
            this.$router.push({ name: "add_blog"});
        },
        editBlog(item) {
            
            this.$router.push({ path: "edit_blog/" + item.id });
        },
        deleteBlog(item) {
            
            this.dialogDeleteBlog = false
        }
    }

    /* async mounted() {
        await this.getBlogGrid()
    }  */
}
</script>

<style></style>
